import { jsxs as s, jsx as n, Fragment as P } from "react/jsx-runtime";
import O, { useState as B, useMemo as ie, useRef as R, useEffect as ee } from "react";
import { useFormContext as q, useForm as oe, FormProvider as ce } from "react-hook-form";
const le = "_title_kmp2b_26", se = "_icon_kmp2b_34", _e = "_arrow_kmp2b_42", j = {
  "container-NYTD": "_container-NYTD_kmp2b_10",
  "title-container": "_title-container_kmp2b_26",
  title: le,
  icon: se,
  arrow: _e,
  "container-primary": "_container-primary_kmp2b_45",
  "container-secondary": "_container-secondary_kmp2b_80",
  "container-oit": "_container-oit_kmp2b_115"
};
var re = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, V = O.createContext && /* @__PURE__ */ O.createContext(re), de = ["attr", "size", "title"];
function me(e, r) {
  if (e == null) return {};
  var t = ue(e, r), a, i;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(e);
    for (i = 0; i < c.length; i++)
      a = c[i], !(r.indexOf(a) >= 0) && Object.prototype.propertyIsEnumerable.call(e, a) && (t[a] = e[a]);
  }
  return t;
}
function ue(e, r) {
  if (e == null) return {};
  var t = {};
  for (var a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      if (r.indexOf(a) >= 0) continue;
      t[a] = e[a];
    }
  return t;
}
function M() {
  return M = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, M.apply(this, arguments);
}
function Z(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function L(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Z(Object(t), !0).forEach(function(a) {
      he(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Z(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function he(e, r, t) {
  return r = pe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function pe(e) {
  var r = fe(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function fe(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function ne(e) {
  return e && e.map((r, t) => /* @__PURE__ */ O.createElement(r.tag, L({
    key: t
  }, r.attr), ne(r.child)));
}
function g(e) {
  return (r) => /* @__PURE__ */ O.createElement(ge, M({
    attr: L({}, e.attr)
  }, r), ne(e.child));
}
function ge(e) {
  var r = (t) => {
    var {
      attr: a,
      size: i,
      title: c
    } = e, o = me(e, de), l = i || t.size || "1em", _;
    return t.className && (_ = t.className), e.className && (_ = (_ ? _ + " " : "") + e.className), /* @__PURE__ */ O.createElement("svg", M({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, t.attr, a, o, {
      className: _,
      style: L(L({
        color: e.color || t.color
      }, t.style), e.style),
      height: l,
      width: l,
      xmlns: "http://www.w3.org/2000/svg"
    }), c && /* @__PURE__ */ O.createElement("title", null, c), e.children);
  };
  return V !== void 0 ? /* @__PURE__ */ O.createElement(V.Consumer, null, (t) => r(t)) : r(re);
}
function ye(e) {
  return g({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "polyline", attr: { points: "6 9 12 15 18 9" }, child: [] }] })(e);
}
function be(e) {
  return g({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "polyline", attr: { points: "18 15 12 9 6 15" }, child: [] }] })(e);
}
function $e(e) {
  return g({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "circle", attr: { cx: "12", cy: "12", r: "10" }, child: [] }, { tag: "line", attr: { x1: "12", y1: "16", x2: "12", y2: "12" }, child: [] }, { tag: "line", attr: { x1: "12", y1: "8", x2: "12.01", y2: "8" }, child: [] }] })(e);
}
function mr({ title: e, content: r, variant: t = "primary" }) {
  const [a, i] = B(!1);
  return /* @__PURE__ */ s("div", { className: `${j[`container-${t}`]} `, children: [
    /* @__PURE__ */ s("div", { id: "title-container", className: `${j["title-container"]} `, onClick: () => i(!a), children: [
      /* @__PURE__ */ s("span", { className: `${j.icon}`, children: [
        " ",
        /* @__PURE__ */ n($e, {})
      ] }),
      /* @__PURE__ */ n("h3", { className: `${j.title}`, children: e }),
      /* @__PURE__ */ n("button", { className: `${j.icon} ${j.arrow}`, "aria-label": a ? "Close" : "Open", children: a ? /* @__PURE__ */ n(be, {}) : /* @__PURE__ */ n(ye, {}) })
    ] }),
    a && /* @__PURE__ */ n("div", { children: /* @__PURE__ */ n("p", { children: r }) })
  ] });
}
const ve = "_content_1o8y3_20", Ne = "_icon_1o8y3_23", F = {
  "container-NYTD": "_container-NYTD_1o8y3_9",
  content: ve,
  icon: Ne,
  "container-primary": "_container-primary_1o8y3_32",
  "container-secondary": "_container-secondary_1o8y3_55"
};
function ur({
  label: e,
  icon: r,
  iconColor: t,
  iconSize: a,
  variant: i = "primary",
  mode: c = "dark",
  onClick: o
}) {
  return /* @__PURE__ */ n("button", { className: `${F[`container-${i}`]}`, onClick: o, "aria-label": `Click for action: ${e}`, children: r ? /* @__PURE__ */ s("div", { className: F.content, children: [
    /* @__PURE__ */ n("div", { className: `${F.icon}`, style: { color: t, fontSize: a }, children: r }),
    /* @__PURE__ */ n("p", { children: e })
  ] }) : /* @__PURE__ */ n("p", { children: e }) });
}
const we = "_icon_3g1sw_58", ke = "_caption_3g1sw_84", x = {
  "btn-small": "_btn-small_3g1sw_10",
  "btn-medium": "_btn-medium_3g1sw_16",
  "btn-large": "_btn-large_3g1sw_22",
  "btn-full-width": "_btn-full-width_3g1sw_29",
  "container-NYTD-dark": "_container-NYTD-dark_3g1sw_35",
  icon: we,
  caption: ke,
  "option-error": "_option-error_3g1sw_93",
  "option-caution": "_option-caution_3g1sw_110",
  "option-info": "_option-info_3g1sw_126",
  "container-primary-dark": "_container-primary-dark_3g1sw_144",
  "container-secondary-dark": "_container-secondary-dark_3g1sw_253",
  "container-NYTD-light": "_container-NYTD-light_3g1sw_362",
  "container-primary-light": "_container-primary-light_3g1sw_471",
  "container-secondary-light": "_container-secondary-light_3g1sw_580"
};
function hr({
  value: e,
  name: r,
  caption: t,
  size: a = "medium",
  image: i,
  iconPosition: c,
  disabled: o = !1,
  type: l = "button",
  variant: _ = "primary",
  mode: d = "dark",
  onClick: h,
  option: m,
  fullWidth: u,
  className: p
}) {
  return /* @__PURE__ */ n(
    "button",
    {
      className: `
        ${x[`container-${_}-${d}`]} 
        ${x[`option-${m}`]} 
        ${x[`btn-${a}`]} 
        ${u ? x["btn-full-width"] : ""} 
        ${x[`mode-${d}`]} ${p}`,
      type: l,
      onClick: h,
      "aria-label": `Click for action: ${t}`,
      disabled: o,
      value: e,
      name: r,
      children: i && c == "Right" ? /* @__PURE__ */ s(P, { children: [
        t,
        /* @__PURE__ */ s("div", { className: `${x.icon}`, children: [
          " ",
          i,
          " "
        ] })
      ] }) : /* @__PURE__ */ s(P, { children: [
        /* @__PURE__ */ s("div", { className: `${x.icon}`, children: [
          " ",
          i,
          " "
        ] }),
        t
      ] })
    }
  );
}
const Ce = {
  "container-NYTD": "_container-NYTD_1vtn2_10",
  "container-primary": "_container-primary_1vtn2_27",
  "container-secondary": "_container-secondary_1vtn2_44"
};
function pr({
  header: e,
  content: r,
  variant: t = "primary",
  mode: a,
  bgColor: i,
  borderColor: c,
  txtColor: o,
  width: l,
  image: _,
  children: d
}) {
  const h = ie(() => {
    const m = {};
    return i && (m.backgroundColor = i), c && (m.border = `1px solid ${c}`), o && (m.color = o), l && (m.width = l), m;
  }, [i, c, o]);
  return /* @__PURE__ */ s(
    "div",
    {
      className: `${Ce[`container-${t}`]}`,
      style: h,
      children: [
        _ && /* @__PURE__ */ n("div", { children: /* @__PURE__ */ n("img", { src: _.src, alt: _.imgAlt }) }),
        (e || r) && /* @__PURE__ */ s("div", { children: [
          /* @__PURE__ */ n("h3", { children: e }),
          /* @__PURE__ */ n("p", { children: r })
        ] }),
        /* @__PURE__ */ n("div", { children: d })
      ]
    }
  );
}
const E = {
  "choice-small": "_choice-small_6rlpc_10",
  "choice-medium": "_choice-medium_6rlpc_15",
  "choice-large": "_choice-large_6rlpc_20",
  "container-NYTD": "_container-NYTD_6rlpc_25",
  "checkbox-input": "_checkbox-input_6rlpc_51",
  "container-primary": "_container-primary_6rlpc_72",
  "container-secondary": "_container-secondary_6rlpc_119",
  "container-oit": "_container-oit_6rlpc_166"
};
function fr({ id: e, size: r, text: t, value: a, checked: i, name: c, ariaLabel: o = "", onChange: l, variant: _ = "primary", disabled: d }) {
  const h = q();
  h?.formState?.errors;
  const m = h?.register, u = !!m;
  return /* @__PURE__ */ s("label", { htmlFor: e, className: `${E[`container-${_}`]}`, children: [
    u ? /* @__PURE__ */ n(
      "input",
      {
        type: "checkbox",
        className: `${E["checkbox-input"]}`,
        id: e,
        value: a,
        ...m ? m(c) : {},
        disabled: d,
        "aria-label": o || t,
        onChange: l
      }
    ) : /* @__PURE__ */ n(
      "input",
      {
        type: "checkbox",
        className: `${E["checkbox-input"]}`,
        id: e,
        value: a,
        name: c,
        disabled: d,
        "aria-label": o || t,
        onChange: l,
        checked: i
      }
    ),
    t
  ] });
}
const A = {
  "choice-small": "_choice-small_96klj_10",
  "choice-medium": "_choice-medium_96klj_15",
  "choice-large": "_choice-large_96klj_20",
  "container-NYTD": "_container-NYTD_96klj_25",
  "radio-input": "_radio-input_96klj_51",
  "container-primary": "_container-primary_96klj_72",
  "container-secondary": "_container-secondary_96klj_119"
};
function gr({ id: e, size: r, text: t, value: a, checked: i, name: c, ariaLabel: o = "", onChange: l, variant: _ = "primary", disabled: d }) {
  const m = q()?.register, u = !!m;
  return /* @__PURE__ */ s("label", { htmlFor: e, className: `${A[`container-${_}`]} `, children: [
    u ? /* @__PURE__ */ n(
      "input",
      {
        type: "radio",
        className: `${A["radio-input"]}`,
        id: e,
        value: a,
        ...m ? m(c) : {},
        disabled: d,
        "aria-label": o || t,
        onChange: l
      }
    ) : /* @__PURE__ */ n(
      "input",
      {
        type: "radio",
        className: `${A["radio-input"]}`,
        id: e,
        value: a,
        name: c,
        disabled: d,
        "aria-label": o || t,
        onChange: l,
        checked: i
      }
    ),
    t
  ] });
}
const Q = {
  "image-sm": "_image-sm_szu9o_9",
  "image-md": "_image-md_szu9o_13",
  "image-lg": "_image-lg_szu9o_17",
  "container-NYTD": "_container-NYTD_szu9o_21",
  "container-primary": "_container-primary_szu9o_57",
  "container-secondary": "_container-secondary_szu9o_93",
  "container-oit": "_container-oit_szu9o_129"
};
function yr({
  copyright: e,
  externalLinks: r,
  variant: t = "primary",
  logo: a,
  logoSize: i = "md",
  children: c,
  fontSize: o = "sm"
}) {
  return /* @__PURE__ */ s("footer", { className: `${Q[`container-${t}`]} font-${o}`, children: [
    a && /* @__PURE__ */ n("img", { className: `${Q[`image-${i}`]}`, src: a.src, alt: a.imgAlt }),
    c && /* @__PURE__ */ n("div", { children: c }),
    r && /* @__PURE__ */ s("ul", { children: [
      r.map((l, _) => /* @__PURE__ */ n(
        "li",
        {
          children: /* @__PURE__ */ n(
            "a",
            {
              target: "_blank",
              "aria-label": `Open a new window for ${l.label} information`,
              href: l.href,
              children: l.label
            }
          )
        },
        _
      )),
      /* @__PURE__ */ n("li", { children: e })
    ] }),
    !r && /* @__PURE__ */ n("p", { children: e })
  ] });
}
function br({ children: e, onSubmit: r, defaultValues: t, validationSchema: a }) {
  const i = oe({ defaultValues: t, resolver: a }), { handleSubmit: c } = i;
  return /* @__PURE__ */ n(ce, { ...i, children: /* @__PURE__ */ n("form", { onSubmit: c(r), children: e }) });
}
function H(e) {
  return g({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M12.884 2.532c-.346-.654-1.422-.654-1.768 0l-9 17A.999.999 0 0 0 3 21h18a.998.998 0 0 0 .883-1.467L12.884 2.532zM13 18h-2v-2h2v2zm-2-4V9h2l.001 5H11z" }, child: [] }] })(e);
}
const xe = "_message_1tnzd_28", ze = "_error_1tnzd_36", z = {
  "container-NYTD": "_container-NYTD_1tnzd_9",
  "message-container": "_message-container_1tnzd_28",
  message: xe,
  error: ze,
  "error-icon": "_error-icon_1tnzd_40",
  "container-primary": "_container-primary_1tnzd_48",
  "container-secondary": "_container-secondary_1tnzd_87",
  "container-oit": "_container-oit_1tnzd_126"
};
function $r({ id: e, name: r, value: t, defaultValue: a, disabled: i, fontSizeInRem: c, label: o, error: l, message: _, variant: d = "NYTD", type: h = "text", errorMessage: m, regex: u, onChange: p, onBlur: b, placeholder: y, onFocus: C }) {
  const v = q(), $ = v?.formState?.errors, N = v?.register, S = !!N;
  return /* @__PURE__ */ s("div", { className: `${z[`container-${d}`]}`, children: [
    o && /* @__PURE__ */ n("label", { htmlFor: r, children: o }),
    S ? /* @__PURE__ */ n(
      "input",
      {
        id: e || r,
        value: t,
        disabled: i,
        type: h,
        placeholder: y && y,
        className: `${($[r] || l) && `${z.error}`}`,
        onFocus: C,
        style: { fontSize: `${c}rem` },
        "aria-label": o || y,
        autoComplete: "on",
        ...N ? N(r) : {}
      }
    ) : /* @__PURE__ */ n(
      "input",
      {
        id: e || r,
        value: t,
        disabled: i,
        type: h,
        placeholder: y,
        className: `${l && `${z.error}`}`,
        onFocus: C,
        onChange: p,
        onBlur: b,
        style: { fontSize: `${c}px` },
        "aria-label": o || y,
        name: r,
        autoComplete: "on"
      }
    ),
    !$?.[r] && !m && _ && /* @__PURE__ */ n("div", { className: `${z["message-container"]}`, children: /* @__PURE__ */ n("p", { className: `${z.message}`, children: _ }) }),
    ($?.[r] || l) && /* @__PURE__ */ s("div", { className: `${z["message-container"]}`, children: [
      /* @__PURE__ */ n(H, { className: `${z["error-icon"]}` }),
      /* @__PURE__ */ n("p", { children: $?.[r]?.message || m })
    ] })
  ] });
}
const G = {
  "label-small": "_label-small_2ylih_10",
  "label-medium": "_label-medium_2ylih_15",
  "label-large": "_label-large_2ylih_20",
  "container-NYTD": "_container-NYTD_2ylih_26",
  "container-primary": "_container-primary_2ylih_36",
  "container-secondary": "_container-secondary_2ylih_46"
};
function vr({ label: e, size: r, ariaLabel: t = "", variant: a = "primary" }) {
  return /* @__PURE__ */ n("div", { className: `${G[`container-${a}`]} ${G[`label-${r}`]}`, children: /* @__PURE__ */ n("span", { "aria-label": t, children: e }) });
}
function K(e) {
  return g({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M400 480a16 16 0 0 1-10.63-4L256 357.41 122.63 476A16 16 0 0 1 96 464V96a64.07 64.07 0 0 1 64-64h192a64.07 64.07 0 0 1 64 64v368a16 16 0 0 1-16 16z" }, child: [] }] })(e);
}
function De(e) {
  return g({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinejoin: "round", strokeWidth: "32", d: "M416 221.25V416a48 48 0 0 1-48 48H144a48 48 0 0 1-48-48V96a48 48 0 0 1 48-48h98.75a32 32 0 0 1 22.62 9.37l141.26 141.26a32 32 0 0 1 9.37 22.62z" }, child: [] }, { tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32", d: "M256 56v120a32 32 0 0 0 32 32h120m-232 80h160m-160 80h160" }, child: [] }] })(e);
}
function Te(e) {
  return g({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "circle", attr: { cx: "152", cy: "184", r: "72" }, child: [] }, { tag: "path", attr: { d: "M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z" }, child: [] }, { tag: "path", attr: { d: "M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z" }, child: [] }, { tag: "circle", attr: { cx: "340", cy: "168", r: "88" }, child: [] }] })(e);
}
function Oe(e) {
  return g({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M449.07 399.08 278.64 82.58c-12.08-22.44-44.26-22.44-56.35 0L51.87 399.08A32 32 0 0 0 80 446.25h340.89a32 32 0 0 0 28.18-47.17zm-198.6-1.83a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm21.72-201.15-5.74 122a16 16 0 0 1-32 0l-5.74-121.95a21.73 21.73 0 0 1 21.5-22.69h.21a21.74 21.74 0 0 1 21.73 22.7z" }, child: [] }] })(e);
}
const je = "_overlay_1tz1s_9", Ye = "_header_1tz1s_64", Be = "_icon_1tz1s_77", qe = "_body_1tz1s_88", Se = "_paragraph_1tz1s_96", Pe = "_heading_1tz1s_105", Me = "_footer_1tz1s_113", w = {
  overlay: je,
  "modal-small": "_modal-small_1tz1s_22",
  "modal-medium": "_modal-medium_1tz1s_31",
  "modal-large": "_modal-large_1tz1s_40",
  "container-NYTD": "_container-NYTD_1tz1s_44",
  header: Ye,
  icon: Be,
  body: qe,
  paragraph: Se,
  heading: Pe,
  footer: Me,
  "container-primary": "_container-primary_1tz1s_129",
  "container-secondary": "_container-secondary_1tz1s_214"
};
function U(e) {
  return g({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" }, child: [] }] })(e);
}
function Le(e) {
  return g({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" }, child: [] }] })(e);
}
function Fe(e) {
  return g({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" }, child: [] }] })(e);
}
function X(e) {
  return g({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" }, child: [] }] })(e);
}
function te(e) {
  return g({ attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" }, child: [] }] })(e);
}
function Nr({ open: e, size: r = "medium", variant: t = "NYTD", children: a, title: i, content: c, bodyContent: o, footerContent: l, headerContent: _, icon: d = "Bookmark", ariaLabel: h = "pop-up window", onClose: m }) {
  const u = () => {
    switch (d) {
      case "Bookmark":
        return /* @__PURE__ */ n(K, {});
      case "Document":
        return /* @__PURE__ */ n(De, {});
      case "People":
        return /* @__PURE__ */ n(Te, {});
      case "Warning":
        return /* @__PURE__ */ n(Oe, {});
      default:
        return /* @__PURE__ */ n(K, {});
    }
  };
  return e ? /* @__PURE__ */ s(P, { children: [
    /* @__PURE__ */ n("div", { className: w.overlay, onClick: m, "aria-hidden": "true" }),
    /* @__PURE__ */ s("div", { className: `${w[`container-${t}`]} ${w[`modal-${r}`]}`, "aria-modal": "true", role: "dialog", "aria-label": h, children: [
      /* @__PURE__ */ s("div", { className: w.header, children: [
        _,
        /* @__PURE__ */ n("div", { className: w.icon, children: u() }),
        /* @__PURE__ */ n("button", { "aria-label": "Close alert", onClick: m, children: /* @__PURE__ */ n(te, {}) })
      ] }),
      /* @__PURE__ */ s("div", { className: w.body, children: [
        i && /* @__PURE__ */ n("h3", { className: w.heading, children: i }),
        c && /* @__PURE__ */ n("p", { className: w.paragraph, children: c }),
        o,
        a
      ] }),
      l && /* @__PURE__ */ n("div", { className: w.footer, children: l })
    ] })
  ] }) : null;
}
const Ee = "_open_1t4lt_19", Ae = "_closed_1t4lt_23", We = "_logo_1t4lt_27", He = "_header_1t4lt_36", Ie = "_hamburger_1t4lt_54", f = {
  "container-NYTD": "_container-NYTD_1t4lt_9",
  open: Ee,
  closed: Ae,
  logo: We,
  "compound-logo": "_compound-logo_1t4lt_33",
  header: He,
  "mobile-menu": "_mobile-menu_1t4lt_42",
  "open-btn": "_open-btn_1t4lt_42",
  "menu-text": "_menu-text_1t4lt_49",
  hamburger: Ie,
  "closing-btn": "_closing-btn_1t4lt_58",
  "mobile-nav": "_mobile-nav_1t4lt_80",
  "desktop-menu": "_desktop-menu_1t4lt_91",
  "container-primary": "_container-primary_1t4lt_123",
  "container-secondary": "_container-secondary_1t4lt_234",
  "container-oit": "_container-oit_1t4lt_345"
};
function Re(e) {
  return g({ attr: { viewBox: "0 0 24 24", fill: "none" }, child: [{ tag: "path", attr: { d: "M6.2253 4.81108C5.83477 4.42056 5.20161 4.42056 4.81108 4.81108C4.42056 5.20161 4.42056 5.83477 4.81108 6.2253L10.5858 12L4.81114 17.7747C4.42062 18.1652 4.42062 18.7984 4.81114 19.1889C5.20167 19.5794 5.83483 19.5794 6.22535 19.1889L12 13.4142L17.7747 19.1889C18.1652 19.5794 18.7984 19.5794 19.1889 19.1889C19.5794 18.7984 19.5794 18.1652 19.1889 17.7747L13.4142 12L19.189 6.2253C19.5795 5.83477 19.5795 5.20161 19.189 4.81108C18.7985 4.42056 18.1653 4.42056 17.7748 4.81108L12 10.5858L6.2253 4.81108Z", fill: "currentColor" }, child: [] }] })(e);
}
function Ve(e) {
  return g({ attr: { viewBox: "0 0 24 24", fill: "none" }, child: [{ tag: "path", attr: { d: "M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z", fill: "currentColor" }, child: [] }, { tag: "path", attr: { d: "M2 12.0322C2 11.4799 2.44772 11.0322 3 11.0322H21C21.5523 11.0322 22 11.4799 22 12.0322C22 12.5845 21.5523 13.0322 21 13.0322H3C2.44772 13.0322 2 12.5845 2 12.0322Z", fill: "currentColor" }, child: [] }, { tag: "path", attr: { d: "M3 17.0645C2.44772 17.0645 2 17.5122 2 18.0645C2 18.6167 2.44772 19.0645 3 19.0645H21C21.5523 19.0645 22 18.6167 22 18.0645C22 17.5122 21.5523 17.0645 21 17.0645H3Z", fill: "currentColor" }, child: [] }] })(e);
}
function wr({
  logo: e,
  caption: r,
  externalLinks: t,
  variant: a = "primary",
  children: i,
  logoHref: c
}) {
  const [o, l] = B(!1), _ = R(null), d = R(null), h = () => {
    l(!o);
  }, m = () => {
    l(!1);
  };
  return ee(() => {
    const u = (p) => {
      o && (d.current && d.current.contains(p.target) || _.current && !_.current.contains(p.target) && m());
    };
    return o && document.addEventListener("mousedown", u), () => {
      document.removeEventListener("mousedown", u);
    };
  }, [o]), // Main container
  /* @__PURE__ */ s("div", { className: `${f[`container-${a}`]} `, children: [
    /* @__PURE__ */ s("div", { className: `${f.header} ${o ? `${f.open}` : `${f.closed}`}`, children: [
      /* @__PURE__ */ s("a", { ...c && { href: c }, id: "logo", children: [
        r,
        e && Array.isArray(e) ? /* @__PURE__ */ n("div", { className: `${f["compound-logo"]}`, children: e.map((u, p) => /* @__PURE__ */ n("img", { src: u.src, alt: u.altText, style: { width: u.width ? `${u.width}px` : "" } }, p)) }) : /* @__PURE__ */ n("div", { className: `${f.logo}`, children: /* @__PURE__ */ n("img", { src: e?.src, alt: e?.altText }) })
      ] }),
      /* @__PURE__ */ n("div", { className: `${f["mobile-menu"]}`, onClick: h, ref: d, children: o ? /* @__PURE__ */ n("button", { "aria-label": "Close menu", className: `${f["closing-btn"]}`, children: /* @__PURE__ */ n(Re, {}) }) : /* @__PURE__ */ n("div", { className: `${f.hamburger}`, children: /* @__PURE__ */ s("button", { "aria-label": "Open menu", className: `${f["open-btn"]}`, children: [
        /* @__PURE__ */ n(Ve, {}),
        /* @__PURE__ */ n("p", { className: `${f["menu-text"]}`, children: "Menu" })
      ] }) }) })
    ] }),
    o && /* @__PURE__ */ n("div", { className: `${f["mobile-nav"]}`, ref: _, children: /* @__PURE__ */ s("nav", { onClick: m, children: [
      t?.map((u, p) => /* @__PURE__ */ n(
        "a",
        {
          href: u.url,
          className: `${f["nav-link"]}`,
          children: u.text
        },
        p
      )),
      i
    ] }) }),
    /* @__PURE__ */ n("div", { className: `${f["desktop-menu"]}`, children: /* @__PURE__ */ s("nav", { children: [
      t?.map((u, p) => /* @__PURE__ */ n(
        "a",
        {
          href: u.url,
          className: `${f["nav-link"]}`,
          children: u.text
        },
        p
      )),
      i
    ] }) })
  ] });
}
const Ze = "_overlay_1q45h_8", Qe = "_header_1q45h_68", Ge = "_icon_1q45h_81", Ke = "_body_1q45h_92", Ue = "_paragraph_1q45h_100", Xe = "_heading_1q45h_109", Je = "_footer_1q45h_117", k = {
  overlay: Ze,
  "modal-small": "_modal-small_1q45h_21",
  "modal-medium": "_modal-medium_1q45h_30",
  "modal-large": "_modal-large_1q45h_39",
  "container-error": "_container-error_1q45h_43",
  header: Qe,
  icon: Ge,
  body: Ke,
  paragraph: Ue,
  heading: Xe,
  footer: Je,
  "container-caution": "_container-caution_1q45h_133",
  "container-info": "_container-info_1q45h_223"
};
function kr({ open: e, type: r = "info", title: t, content: a, onClose: i, bodyContent: c, footerContent: o, headerContent: l, ariaLabel: _ = "pop-up alert", children: d, size: h = "medium" }) {
  const m = () => {
    switch (r) {
      case "error":
        return /* @__PURE__ */ n(Le, {});
      case "caution":
        return /* @__PURE__ */ n(Fe, {});
      case "info":
        return /* @__PURE__ */ n(X, {});
      default:
        return /* @__PURE__ */ n(X, {});
    }
  };
  return e ? /* @__PURE__ */ s(P, { children: [
    /* @__PURE__ */ n("div", { className: k.overlay, onClick: i, "aria-hidden": "true" }),
    /* @__PURE__ */ s("div", { className: `${k[`container-${r}`]}`, "aria-modal": "true", role: "dialog", "aria-label": _, children: [
      /* @__PURE__ */ s("div", { className: k.header, children: [
        l,
        /* @__PURE__ */ n("div", { className: k.icon, children: m() }),
        /* @__PURE__ */ n("button", { "aria-label": "Close alert", onClick: i, children: /* @__PURE__ */ n(te, {}) })
      ] }),
      /* @__PURE__ */ s("div", { className: k.body, children: [
        t && /* @__PURE__ */ n("h3", { className: k.heading, children: t }),
        a && /* @__PURE__ */ n("p", { className: k.paragraph, children: a }),
        c,
        d
      ] }),
      o && /* @__PURE__ */ n("div", { className: k.footer, children: o })
    ] })
  ] }) : null;
}
const er = "_message_kbsh9_28", rr = "_error_kbsh9_36", D = {
  "container-NYTD": "_container-NYTD_kbsh9_9",
  "message-container": "_message-container_kbsh9_28",
  message: er,
  error: rr,
  "error-icon": "_error-icon_kbsh9_40",
  "container-primary": "_container-primary_kbsh9_48",
  "container-secondary": "_container-secondary_kbsh9_87"
};
function Cr({ id: e, name: r, value: t, defaultValue: a, disabled: i, fontSizeInRem: c, label: o, error: l, message: _, variant: d = "NYTD", errorMessage: h, regex: m, onChange: u, onBlur: p, placeholder: b, onFocus: y }) {
  const C = q(), v = C?.formState?.errors, $ = C?.register, N = !!$;
  return /* @__PURE__ */ s("div", { className: `${D[`container-${d}`]}`, children: [
    o && /* @__PURE__ */ n("label", { htmlFor: r, children: o }),
    N ? /* @__PURE__ */ n(
      "textarea",
      {
        id: e || r,
        value: t,
        disabled: i,
        placeholder: b && b,
        className: `${(v[r] || l) && `${D.error}`}`,
        onFocus: y,
        style: { fontSize: `${c}rem` },
        "aria-label": o || b,
        autoComplete: "on",
        ...$ ? $(r) : {}
      }
    ) : /* @__PURE__ */ n(
      "textarea",
      {
        id: e || r,
        value: t,
        disabled: i,
        placeholder: b,
        className: `${l && `${D.error}`}`,
        onFocus: y,
        onChange: u,
        onBlur: p,
        style: { fontSize: `${c}px` },
        "aria-label": o || b,
        name: r,
        autoComplete: "on"
      }
    ),
    !v?.[r] && !h && _ && /* @__PURE__ */ n("div", { className: `${D["message-container"]}`, children: /* @__PURE__ */ n("p", { className: `${D.message}`, children: _ }) }),
    (v?.[r] || l) && /* @__PURE__ */ s("div", { className: `${D["message-container"]}`, children: [
      /* @__PURE__ */ n(H, { className: `${D["error-icon"]}` }),
      /* @__PURE__ */ n("p", { children: v?.[r]?.message || h })
    ] })
  ] });
}
const nr = "_header_winn2_19", T = {
  "container-NYTD": "_container-NYTD_winn2_9",
  "header-no-label": "_header-no-label_winn2_19",
  header: nr,
  "progress-bar-no-label": "_progress-bar-no-label_winn2_35",
  "progress-bar-with-label": "_progress-bar-with-label_winn2_45",
  "fill-no-label": "_fill-no-label_winn2_55",
  "fill-with-label": "_fill-with-label_winn2_64",
  "container-primary": "_container-primary_winn2_74",
  "container-secondary": "_container-secondary_winn2_139"
};
function xr({ total: e, partial: r, showLabel: t = "none", variant: a = "primary", ariaLabel: i = "Your progress", mode: c = "dark" }) {
  const [o, l] = B();
  ee(() => {
    let d = r / e * 100;
    r <= 0 && d <= 0 ? l(0) : r <= e ? (d = Math.floor(d), l(d)) : r >= e && l(100);
  }, [r, e]);
  const _ = function(d) {
    if (d === "percentage")
      return /* @__PURE__ */ s("div", { role: "note", id: "title", "aria-label": `Question ${r} of ${e}`, children: [
        "You are ",
        o,
        "% through"
      ] });
    if (d === "numbers")
      return /* @__PURE__ */ s("div", { role: "note", id: "title", "aria-label": `Question ${r} of ${e}`, children: [
        "Question ",
        r,
        " of ",
        e
      ] });
    if (d === "none")
      return;
  };
  return /* @__PURE__ */ s("div", { className: `${T[`container-${a}`]}`, "aria-label": t === "none" ? i : "", role: "meter", "aria-labelledby": t !== "none" ? "title" : "", "aria-valuenow": r, children: [
    /* @__PURE__ */ n("div", { className: `${t === "none" ? T["header-no-label"] : T.header}`, children: _(t) }),
    /* @__PURE__ */ n("div", { className: `${t === "none" ? T["progress-bar-no-label"] : T["progress-bar-with-label"]}`, children: /* @__PURE__ */ n("div", { className: `${t === "none" ? T["fill-no-label"] : T["fill-with-label"]}`, style: { width: `${o}%` } }) })
  ] });
}
const tr = "_spinner_1qmqf_15", ar = "_spin_1qmqf_15", ir = "_caption_1qmqf_23", W = {
  "container-NYTD": "_container-NYTD_1qmqf_9",
  spinner: tr,
  spin: ar,
  caption: ir,
  "container-primary": "_container-primary_1qmqf_34",
  "container-secondary": "_container-secondary_1qmqf_59"
};
function zr({ isLoading: e, variant: r = "primary", caption: t = "Loading...", displayCaption: a = !0, displaySpinner: i = !0 }) {
  const [c, o] = B();
  return e ? /* @__PURE__ */ s("div", { className: `${W[`container-${r}`]}`, children: [
    i && /* @__PURE__ */ n("div", { className: W.spinner }),
    a && /* @__PURE__ */ n("p", { className: W.caption, children: t })
  ] }) : null;
}
const or = "_switchWrapper_kuqpj_21", J = {
  "container-NYTD": "_container-NYTD_kuqpj_9",
  switchWrapper: or,
  "container-primary": "_container-primary_kuqpj_61",
  "container-secondary": "_container-secondary_kuqpj_113"
};
function Dr({ option1: e, option2: r, variant: t = "primary", caption: a = "Switch button", displayCaption: i = !1, initialState: c = e.value, onToggle: o }) {
  const [l, _] = B(c), d = (h) => {
    h.stopPropagation();
    const m = l === e.value ? r.value : e.value;
    o?.(m), _(m);
  };
  return /* @__PURE__ */ s("section", { className: J[`container-${t}`], role: "group", "aria-label": a, children: [
    i && a && /* @__PURE__ */ s("p", { children: [
      a,
      ":"
    ] }),
    /* @__PURE__ */ s("div", { className: J.switchWrapper, children: [
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          role: "switch",
          "aria-checked": l === e.value,
          onClick: (h) => d(h),
          children: [
            l === e.value && /* @__PURE__ */ n(U, {}),
            e.label
          ]
        }
      ),
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          role: "switch",
          "aria-checked": l === r.value,
          onClick: (h) => d(h),
          children: [
            r.label,
            l === r.value && /* @__PURE__ */ n(U, {})
          ]
        }
      )
    ] })
  ] });
}
const cr = "_message_rlllu_24", lr = "_error_rlllu_32", Y = {
  "container-NYTD": "_container-NYTD_rlllu_8",
  "message-container": "_message-container_rlllu_24",
  message: cr,
  error: lr,
  "error-icon": "_error-icon_rlllu_36",
  "container-primary": "_container-primary_rlllu_44",
  "container-oit": "_container-oit_rlllu_80"
};
function Tr({ id: e, name: r, placeholder: t, label: a, selectedValue: i, options: c, disabled: o, error: l, variant: _ = "primary", errorMessage: d, onChange: h, onBlur: m, onFocus: u }) {
  const p = q(), b = p?.formState?.errors, y = p?.register, C = !!y;
  return /* @__PURE__ */ s("div", { className: `${Y[`container-${_}`]}`, children: [
    a && /* @__PURE__ */ n("label", { htmlFor: r, children: a }),
    // RHF Select
    C ? /* @__PURE__ */ s(
      "select",
      {
        id: e || r,
        disabled: o,
        className: `${(b[r] || l) && `${Y.error}`}`,
        value: i || "",
        onFocus: u,
        "aria-label": a,
        ...y ? y(r) : {},
        children: [
          t && v(t),
          c && c.length && $(c)
        ]
      }
    ) : /* @__PURE__ */ s(
      "select",
      {
        id: e || r,
        name: r,
        disabled: o,
        className: `${l && `${Y.error}`}`,
        value: i || "",
        onChange: h,
        onBlur: m,
        onFocus: u,
        "aria-label": a,
        children: [
          t && v(t),
          c && c.length && $(c)
        ]
      }
    ),
    (b?.[r] || l) && /* @__PURE__ */ s("div", { className: `${Y["message-container"]}`, children: [
      /* @__PURE__ */ n(H, { className: `${Y["error-icon"]}` }),
      /* @__PURE__ */ n("p", { children: b?.[r]?.message || d })
    ] })
  ] });
  function v(N) {
    return /* @__PURE__ */ n("option", { value: "", children: N });
  }
  function $(N) {
    let S = [];
    return N.map((I, ae) => {
      S.push(
        /* @__PURE__ */ n("option", { value: I.value, children: I.text }, ae)
      );
    }), S;
  }
}
export {
  mr as Accordion,
  ur as ActionCall,
  kr as Alert,
  hr as Button,
  pr as Card,
  fr as CheckBox,
  Tr as Dropdown,
  yr as Footer,
  br as Form,
  $r as Input,
  vr as Label,
  zr as Loader,
  Nr as Modal,
  wr as NavBar,
  xr as ProgressBar,
  gr as RadioSelector,
  Cr as Textarea,
  Dr as ToggleButton
};
//# sourceMappingURL=index.esm.js.map
